export enum FeedbackType {
  BUG_REPORT,
  FEATURE_REQUEST,
  IMPROVEMENT,
  OTHER,
  QUESTION,
  _SIZE,
}
